import React, { useEffect, useState } from "react";
import { collection, getDocs, query, where, Timestamp } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export default function IaSessionsCard() {
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadIaSessions() {
      try {
        const now = new Date();
        const last24h = new Date(now.getTime() - 24 * 60 * 60 * 1000);

        // 🔥 Busca sessões criadas nas últimas 24 horas
        const qIa = query(
          collection(db, "ai_sessions"),
          where("createdAt", ">=", Timestamp.fromDate(last24h))
        );

        const snap = await getDocs(qIa);
        setCount(snap.size);
      } catch (error) {
        console.error("Erro ao buscar sessões da IA:", error);
      } finally {
        setLoading(false);
      }
    }

    loadIaSessions();
  }, []);

  return (
    <div className="metric-card">
      <p className="metric-label">Sessões IA (24h)</p>

      <p className="metric-value">
        {loading || count === null ? "..." : count.toLocaleString("pt-BR")}
      </p>

      <span className="metric-tag">Conversas com a IA do Amor</span>
    </div>
  );
}
